import axios from 'axios';

interface IAxiosReq {
  url: string;
  method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
  data?: any;
  headers?: any;
}

const axiosCall = async ({
  url, method, data, headers,
}: IAxiosReq) => {
  const response = await axios({
    url,
    method,
    data,
    headers,
  });

  return response;
};

export default axiosCall;
